module.exports = __webpack_public_path__ + "img/feedback-svg.52f7311b.png";